__turbopack_context__.v({
  "flatSimilar": "FlatSimilar-module-scss-module__CAS8pa__flatSimilar",
  "flatSimilar__flats": "FlatSimilar-module-scss-module__CAS8pa__flatSimilar__flats",
  "flatSimilar__title": "FlatSimilar-module-scss-module__CAS8pa__flatSimilar__title",
});
